export default class AiError {
  constructor({ header, text, type = 'attention' } = {}) {
    this.header = header ?? 'ai_content_generator.errors.default.header';
    this.text = text ?? 'ai_content_generator.errors.default.text';
    this.type = type;
  }
}
